import React from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { EntryCardPromoTag } from '@/components/entry-card';
import { Box } from '@/components/lib/components';

import { useSbkEntryPromos } from '../components/bet-cards/use-sbk-entry-promos';
import { Bet } from './types';

/**
 * The entry-card tags plus a bonus tag the cards don't show - they surface `is_betr_bucks` through
 * the entry label instead. Null (not an empty Box) so `BetDetailShell` drops the "Promos" header too.
 */
export const useSbkBetDetailPromos = (bet: Bet): ReactNode => {
    const { t } = useTranslation('bets');
    const promos = useSbkEntryPromos(bet, bet.result !== 'PENDING');

    if (!promos && !bet.is_betr_bucks) {
        return null;
    }

    return (
        <Box gap="s8">
            {promos}
            {bet.is_betr_bucks ? <EntryCardPromoTag label={t('placed_with_bonus')} /> : null}
        </Box>
    );
};
